import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, unref as _unref, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "fv" }
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = { class: "fv__main" }
const _hoisted_4 = {
  class: "cloud",
  alt: "let's try"
}
const _hoisted_5 = {
  class: "bln circle",
  alt: ""
}
const _hoisted_6 = {
  class: "bln bln1",
  alt: ""
}
const _hoisted_7 = {
  class: "bln bln2",
  alt: ""
}
const _hoisted_8 = {
  class: "bln star1",
  alt: ""
}
const _hoisted_9 = {
  class: "bln star2",
  alt: ""
}
const _hoisted_10 = {
  class: "bln star3",
  alt: ""
}
const _hoisted_11 = {
  class: "bln triangle",
  alt: ""
}

import cloud from '@/assets/images/fv_cloud.svg'
import circle from '@/assets/images/fv_circle.svg'
import bln1 from '@/assets/images/fv_bln1.svg'
import bln2 from '@/assets/images/fv_bln2.svg'
import star1 from '@/assets/images/fv_star1.svg'
import star2 from '@/assets/images/fv_star2.svg'
import star3 from '@/assets/images/fv_star3.svg'
import triangle from '@/assets/images/fv_triangle.svg'


export default /*@__PURE__*/_defineComponent({
  __name: 'FirstView',
  setup(__props) {

// import text1 from '@/assets/images/fv_text1.svg'
// import text2 from '@/assets/images/fv_text2.svg'
// import text3 from '@/assets/images/fv_text3.svg'
const letters = [
  { src: require('@/assets/images/letter_1.svg'), alt: '性' },
  { src: require('@/assets/images/letter_2.svg'), alt: '各' },
  { src: require('@/assets/images/letter_3.svg'), alt: '各' },
  { src: require('@/assets/images/letter_4.svg'), alt: '各' },
  { src: require('@/assets/images/letter_5.svg'), alt: '各' },
  { src: require('@/assets/images/letter_6.svg'), alt: '各' },
  { src: require('@/assets/images/letter_7.svg'), alt: '各' },
]

return (_ctx: any,_cache: any) => {
  const _directive_lazy = _resolveDirective("lazy")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", null, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(letters, (image, index) => {
        return _createElementVNode("img", {
          key: index,
          src: image.src,
          width: "343",
          height: "98",
          alt: image.alt
        }, null, 8, _hoisted_2)
      }), 64))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _cache[0] || (_cache[0] = _createElementVNode("img", {
        class: "board",
        src: "/common/beauty/diagnosis/osaka/fv_board.svg",
        width: "343",
        height: "253",
        alt: ""
      }, null, -1)),
      _cache[1] || (_cache[1] = _createElementVNode("img", {
        class: "text text1",
        src: "/common/beauty/diagnosis/osaka/fv_text1.svg",
        alt: "質問に答えて、あなたの"
      }, null, -1)),
      _cache[2] || (_cache[2] = _createElementVNode("img", {
        class: "text text2",
        src: "/common/beauty/diagnosis/osaka/fv_text2.svg",
        alt: "性格に合った美容業界の"
      }, null, -1)),
      _cache[3] || (_cache[3] = _createElementVNode("img", {
        class: "text text3",
        src: "/common/beauty/diagnosis/osaka/fv_text3.svg",
        alt: "お仕事を見てみよう"
      }, null, -1)),
      _withDirectives(_createElementVNode("img", _hoisted_4, null, 512), [
        [_directive_lazy, _unref(cloud)]
      ]),
      _withDirectives(_createElementVNode("img", _hoisted_5, null, 512), [
        [_directive_lazy, _unref(circle)]
      ]),
      _withDirectives(_createElementVNode("img", _hoisted_6, null, 512), [
        [_directive_lazy, _unref(bln1)]
      ]),
      _withDirectives(_createElementVNode("img", _hoisted_7, null, 512), [
        [_directive_lazy, _unref(bln2)]
      ]),
      _withDirectives(_createElementVNode("img", _hoisted_8, null, 512), [
        [_directive_lazy, _unref(star1)]
      ]),
      _withDirectives(_createElementVNode("img", _hoisted_9, null, 512), [
        [_directive_lazy, _unref(star2)]
      ]),
      _withDirectives(_createElementVNode("img", _hoisted_10, null, 512), [
        [_directive_lazy, _unref(star3)]
      ]),
      _withDirectives(_createElementVNode("img", _hoisted_11, null, 512), [
        [_directive_lazy, _unref(triangle)]
      ])
    ])
  ]))
}
}

})